import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';
import TextDate from './../../components/text/TextDate';
import TextAmount from './../../components/text/TextAmount';
import DropdownButtonSelect from './../../components/button/DropdownButtonSelect';
import { useAuthContext } from './../../components/special/oAuthProvider';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

const ClaimCalculateStatus = ({ claimID, hideButtons }) => { 
    const { t } = useLocale();
    const { isAuthorized } = useAuthContext();

    const [workingData, setWorkingData] = useState({
        claim: null,
        callInText: "",
        totalClaimCostAmount: 0,
        calculateToResult: null,
        isBond: false
      });

    const loadClaimStatus = async () => {    
        const data = await apiGetCall(BASE_URL + '/claim/' + claimID);
        if (isResultOk(data, null, true)){
            const calculatePostData = {
                claimID: claimID, 
                calculateTo: data.calculationLocked ? data.maxCalculationDate : new Date(), 
                principalsTo: data.calculationLocked ? data.maxCalculationDate : new Date(), 
                calledIn: data.isBond ? data.calledIn : null,
                addNotCalledInRemainderWithInterest : null
            };

            const calculatedData = await apiPostCall(BASE_URL + '/claim/calculate', calculatePostData);
            if (isResultOk(calculatedData, null, true)){
                setWorkingData({
                    claim: calculatedData,
                    callInText: calculatedData.isBond ? calculatedData.calledIn ? "Gjaldfellt : " : "Ógjaldfellt : " : "",
                    totalClaimCostAmount: calculatedData.currentSum.accruedExpense + calculatedData.currentSum.outlaidExpense + calculatedData.currentSum.totalCostPenaltyInterests,
                    calculateToResult: calculatePostData.calculateTo,
                    isBond: calculatedData.isBond
                });
            } 
        }   
    }
    
    useEffect(() => {
        loadClaimStatus();
    }, []); 
 
    return (
        <div className="table-wrap">
            {workingData.claim && 
            <table className="table advanced no-vertical-padding only-vertical-border th-align-middle text-left hover border-top-red">
                <colgroup>
                    <col />            
                    <col width="20%" />
                    <col width="20%" />
                </colgroup>
                <thead>
                    <tr>
                        <th className="no-left-border no-right-border">{t("Staða kröfu")} <small>({workingData.callInText} {t("Reiknað til")} <TextDate value={workingData.calculateToResult}/>)</small></th>
                        <th className="no-left-border no-right-border">
                            {!hideButtons && isAuthorized('3002') && <div className="text-14 bottom text-right"> <Link to={"/calculator?claimid="+claimID}>Sjá í reiknivél</Link></div>}
                        </th>
                        <th className="no-left-border no-right-border" style={{overflow: 'visible'}}>
                            <div className="pull-right relative">
                                {/* á eftir að útfæra  prenta yfirlit listan*/}
                                {!hideButtons && <div className="text-14 bottom text-right"> <Link to="">Prenta yfirlit</Link></div>}
                            </div>
                        </th>
                        {/* <th className="no-left-border no-right-border"></th> */}
                        {/* <th className="no-left-border"></th> */}
                        {/*<th class="no-left-border no-right-border" style="overflow:visible" ng-hide="vm.HideRemaining">                    
                            <div class="pull-right relative">                    
                                <ci-dropdownbutton 
                                    icon=""
                                    text="Prenta yfirlit" 
                                    position="bottom right"  
                                    color="" 
                                    type="text-14"
                                    no-trigger=true; 
                                    listdata="vm.printItems"                     
                                    onitemclick="vm.printPreview(item.id)"
                                    >
                                </ci-dropdownbutton>                                                                          
                            </div>
                        </th>*/}
                    </tr>
                </thead>
                <tbody className="only-vertical-border ">
                    <tr>
                        <th>&nbsp;</th>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <th className="no-right-border"></th>
                        <td className="text-bold text-right">{t("Staða")}</td>
                        <td className="text-bold text-right">{t("Eftirstöðvar")}</td>
                    </tr>
                    <tr>
                        <th className="text-normal">{t("Höfuðstóll")}</th>
                        <td className="text-right"><TextAmount value={workingData.claim.currentSum.principal}/></td>
                        <td className="text-right"><TextAmount value={workingData.claim.remainderSum.principal}/></td>
                    </tr>
                    <tr>
                        <th className="text-normal">{t("Samningsvextir")}</th>
                        <td className="text-right"><TextAmount value={workingData.claim.currentSum.contractInterests}/></td>
                        <td className="text-right"><TextAmount value={workingData.claim.remainderSum.contractInterests}/></td>
                    </tr>
                    <tr>
                        <th className="text-normal">{t("Bankakostnaður")}</th>
                        <td className="text-right"><TextAmount value={workingData.claim.currentSum.bankCost}/></td>
                        <td className="text-right"><TextAmount value={workingData.claim.remainderSum.bankCost}/></td>
                    </tr>
                    <tr>
                        <th className="text-normal">{t("Dráttarvextir")}</th>
                        <td className="text-right"><TextAmount value={workingData.claim.currentSum.penaltyInterests}/></td>
                        <td className="text-right"><TextAmount value={workingData.claim.remainderSum.penaltyInterests}/></td>
                    </tr>
                    <tr>
                        <th className="text-normal">{t("Kostnaður kröfuhafa")}</th>
                        <td className="text-right"><TextAmount value={workingData.claim.currentSum.creditorCost}/></td>
                        <td className="text-right"><TextAmount value={workingData.claim.remainderSum.creditorCost}/></td>
                    </tr>
                    <tr>
                        <th className="text-normal">{t("Áfallinn kostnaður")}</th>
                        <td className="text-right"><TextAmount value={workingData.claim.currentSum.accruedExpense}/></td>
                        <td className="text-right"><TextAmount value={workingData.claim.remainderSum.accruedExpense}/></td>
                    </tr>
                    <tr>
                        <th className="text-normal">{t("Útlagður kostnaður")}</th>
                        <td className="text-right"><TextAmount value={workingData.claim.currentSum.outlaidExpense}/></td>
                        <td className="text-right"><TextAmount value={workingData.claim.remainderSum.outlaidExpense}/></td>
                    </tr>
                    <tr>
                        <th className="text-normal">{t("Vextir af kostnaði")}</th>
                        <td className="text-right"><TextAmount value={workingData.claim.currentSum.totalCostPenaltyInterests}/></td>
                        <td className="text-right"><TextAmount value={workingData.claim.remainderSum.totalCostPenaltyInterests}/></td>
                    </tr>
                    <tr>
                        <th className="text-normal">{t("Virðisaukaskattur")}</th>
                        <td className="text-right"><TextAmount value={workingData.claim.currentSum.totalVat}/></td>
                        <td className="text-right"><TextAmount value={workingData.claim.remainderSum.totalVat}/></td>
                    </tr>
                    <tr>
                        <th className="text-normal padding-top">{t("Afsláttur / niðurfelling")}</th>
                        <td className="text-right padding-top"><TextAmount value={-workingData.claim.currentSum.discountsAndTerminations}/></td>
                        <td className="text-right padding-top"></td>
                    </tr>
                    <tr>
                        <th className="text-normal">{t("Innborgun")}</th>
                        <td className="text-right"><TextAmount value={-workingData.claim.currentSum.payments}/></td>
                        <td className="text-right"></td>
                    </tr>
                    <tr className="text-bold">
                        <th className="padding-top">{t("Samtals")}</th>
                        <td className="padding-top text-right"><TextAmount value={workingData.claim.currentSum.total}/></td>
                        <td className="padding-top text-right"></td>
                    </tr>

                    {workingData.isBond && <tr className="text-bold">
                        <th className="padding-top text-normal">{t("Ógj. eftirst. auk vaxta")}</th>
                        <td className="padding-top text-normal text-right"><TextAmount value={workingData.claim.currentSum.notCalledInRemainderWithInterest}/></td>
                        <td className="padding-top text-normal text-right"></td>
                    </tr>}

                    {workingData.isBond && <tr className="text-bold">
                        <th className="text-normal">{t("Jöfnunarreik.eftirst.")}</th>
                        <td className="text-right text-normal"><TextAmount value={workingData.claim.currentSum.equalizationAccount}/></td>
                        <td className="text-right text-normal"></td>
                    </tr>}
                    <tr>
                        <th className="border">&nbsp;</th>
                        <td className="border">&nbsp;</td>
                        <td className="border">&nbsp;</td>
                    </tr>
                    {workingData.totalClaimCostAmount > 0 && <tr>
                            <th className="padding-top text-normal">{t("Heildarkostnaður")}</th>
                            <td className="padding-top text-right"><TextAmount value={workingData.totalClaimCostAmount}/></td>
                            <td className="padding-top text-right"></td>
                    </tr>}

                    {workingData.totalClaimCostAmount > 0 && <tr>
                            <th className="border">&nbsp;</th>
                            <td className="border">&nbsp;</td>
                            <td className="border">&nbsp;</td>
                    </tr>}
                    
                    {workingData.claim.currentSum.paymentsCreditorOverPaid > 0 && <tr>
                            <th className="padding-top text-normal">{t("Ofgreitt til kröfuhafa")}</th>
                            <td className="padding-top text-right"><span style={{color: 'red'}}><TextAmount value={workingData.claim.currentSum.paymentsCreditorOverPaid}/></span></td>
                            <td className="padding-top text-right"></td>
                    </tr>}

                    {workingData.claim.currentSum.paymentsLawyerOverPaid > 0 && <tr>
                            <th className="padding-top text-normal">{t("Ofgreitt til lögmanns")}</th>
                            <td className="padding-top text-right"><span style={{color: 'red'}}><TextAmount value={workingData.claim.currentSum.paymentsLawyerOverPaid}/></span></td>
                            <td class="padding-top text-right"></td>
                    </tr>}

                    {(workingData.claim.currentSum.paymentsCreditorOverPaid > 0 || workingData.claim.currentSum.paymentsLawyerOverPaid > 0) && <tr>
                            <th className="border">&nbsp;</th>
                            <td className="border">&nbsp;</td>
                            <td className="border">&nbsp;</td>
                    </tr>}              
                </tbody>
            </table>}        
        </div>
    );
};

export default ClaimCalculateStatus;
